var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTexans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Logo Icons / NFL / Texans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Logo-Icons-/-NFL-/-Texans",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOU"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 70 0 70 70 0 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.59638,17.8003 C60.86346,27.14208 51.52812,28.54054 41.9482,29.90484 C41.9482,29.90484 37.9057,28.7889 30.90066,25.30682 C15.0136,17.41082 20.01538,13.69018 32.50156,11.43898 C12.51768,2.72706 -4.13826,17.89522 14.23604,32.64478 L9.19408,36.25146 C13.3357,38.79218 21.917,44.12198 20.6703,52.2837 L16.41122,55.32982 L29.4182,61.22802 L39.68188,56.57386 C39.75636,52.05382 47.82918,49.70616 51.30272,40.5118 C70.42392,36.12168 65.55374,19.29018 48.59624,17.80044",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.80678,45.7051 L30.11932,41.50804 L25.88572,42.13972 L27.8425,38.91384 L24.15588,34.71412 L29.05322,36.91968 L31.00566,33.69296 L32.07344,38.28048 L36.9698,40.48254 L32.73438,41.1159 L33.80664,45.7051 L33.80678,45.7051 Z M39.85604,30.76612 C15.85346,21.4893 14.26404,13.87862 29.24614,11.24844 C10.5091,6.15384 -0.42,19.74266 18.11894,32.70148 L13.14446,36.25986 C18.42666,39.79108 24.02442,45.02162 22.12546,53.25264 L19.6189,55.04324 L29.246,59.41054 C38.20516,49.59066 42.8911,40.0498 39.8559,30.76612 L39.85604,30.76612 Z",
    id: "Shape",
    fill: "#03202F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.04066,19.2619 C60.27826,25.71548 54.55856,29.8389 44.5158,30.95918 C47.05652,41.67646 39.26608,51.49284 31.01798,59.09386 L38.5805,55.66526 C39.1398,51.30944 46.81278,49.0441 50.44858,39.37878 C67.52606,35.56602 64.73894,23.30188 52.04066,19.2619",
    id: "Path",
    fill: "#A71930",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexans);
export default __webpack_public_path__ + "static/media/Texans.f4a3421d51cb71776c3c0188a227a26a.svg";
export { ForwardRef as ReactComponent };